<template>
  <sn-modal
    v-model="showModal"
    title="Still working?"
    type="decision"
    primary-text="Sign out"
    secondary-text="Continue working"
    @submit="logout"
    @secondarySubmit="extendSession"
  >
    <div>{{ bodyText }}</div>
    <div class="mt-6">
      <strong>{{ timeRemainingText }}</strong> minutes left
    </div>
  </sn-modal>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'EvaultSessionTimeoutModal',
  props: {
    display: {
      type: Boolean,
      required: true,
      default: false
    },
    totalSeconds: {
      type: Number,
      required: false,
      default: 5 * 60
    }
  },

  data () {
    return {
      showModal: null,
      secondsRemaining: null,
      timerInterval: null,
      bodyText: 'nCino eVault automatically signs out after being idle for 15 minutes. This helps ensure your information remains secure.'
    }
  },

  computed: {
    timeRemainingText () {
      const secs = this.secondsRemaining % 60
      const minutes = Math.floor(this.secondsRemaining / 60)
      return minutes + ':' + `${secs < 10 ? '0' + secs : secs}`
    }
  },

  watch: {
    display (newVal) {
      this.showModal = newVal
      if (newVal) {
        this.secondsRemaining = this.totalSeconds
        this.timerInterval = setInterval(() => {
          if (this.display && this.secondsRemaining > 0) {
            this.secondsRemaining -= 1
          } else if (this.display) {
            this.logout()
          }
        }, 1000)
      } else {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
    totalSeconds (newVal) {
      if (newVal) {
        this.secondsRemaining = newVal
      } else {
        this.secondsRemaining = 5 * 60
      }
    }
  },

  created () {
    this.showModal = this.display
  },

  methods: {
    ...mapMutations(['resetAppTimeout']),
    extendSession () {
      this.resetAppTimeout()
      this.$emit('extend')
    },
    logout () {
      sessionStorage.clear()
      window.location.assign('/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
